import { render, staticRenderFns } from "./egg-page.vue?vue&type=template&id=60486639&"
import script from "./egg-page.vue?vue&type=script&lang=js&"
export * from "./egg-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports